import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaxNumberPipe } from '../../pipes/max-number.pipe';
import { MinNumberPipe } from '../../pipes/min-number.pipe';
import { SecureUrlPipe } from '../../pipes/secure-url.pipe';
import { SafeUrlPipe } from '../../pipes/safe-url.pipe';

@NgModule({
  declarations: [
    MaxNumberPipe,
    MinNumberPipe,
    SecureUrlPipe,
    SafeUrlPipe,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MaxNumberPipe,
    MinNumberPipe,
    SecureUrlPipe,
    SafeUrlPipe,
  ],
})
export class CustomUtilModule { }
